import { getKcContext } from 'config/kc-context';
import { KcContextUrlExtention } from 'types/kc-context-extentions-types';

export type KcContextUrl = keyof KcContext['url'];

export type KcContextSecureQuestions = { id: KcSecureAnswersTypes, text: string }[];

export type KcContext = NonNullable<ReturnType<typeof getKcContext>['kcContext']> & KcContextUrlExtention;

export enum KcBankAccountType {
  CARD = 'CARD',
  ACCOUNT = 'ACCOUNT',
}

export enum KcSecureAnswersTypes {
  BIRTH_DATE = 'birthDate',
  PASSPORT_NUMBER = 'passportNumber',
  PASSPORT_NUMBER_FOREIGN = 'passportNumberForeign',
  BIRTH_PLACE_CITY_NAME = 'birthPlaceCityName',
  LAW_ADDRESS_CITY_NAME = 'lawAddressCityName',
}
